import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Alert, Box, Chip, CircularProgress, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { useTranslation } from 'react-i18next';
import client from '../api/client';

export default function CourseDetailPage() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [course, setCourse] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    client.get(`/courses/${courseId}`)
      .then(r => {
        const data = r.data;
        setCourse(data);
        if (data.resumeLessonId) {
          navigate(`/courses/${courseId}/lessons/${data.resumeLessonId}`, { replace: true });
        }
      })
      .catch(err => {
        if (err.response?.status === 403) {
          setError('access_denied');
        } else {
          setError('load_failed');
        }
      });
  }, [courseId, navigate]);

  if (error === 'access_denied') {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">{t('courses.noAccess')}</Alert>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{t('courses.loadFailed')}</Alert>
      </Box>
    );
  }

  if (!course) {
    return <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>{course.title}</Typography>
      <List>
        {(course.lessons || []).map(lesson => (
          <ListItem key={lesson.lessonId} disablePadding>
            <ListItemButton onClick={() => navigate(`/courses/${courseId}/lessons/${lesson.lessonId}`)}>
              <ListItemIcon>
                {lesson.passed
                  ? <CheckCircleIcon color="success" />
                  : <RadioButtonUncheckedIcon color="disabled" />}
              </ListItemIcon>
              <ListItemText primary={lesson.title || lesson.lessonId} />
              {lesson.lessonId === course.resumeLessonId && (
                <Chip label={t('courses.resume')} size="small" color="primary" sx={{ ml: 1 }} />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
